<script lang="ts" setup>
import { toRefs } from 'vue';

interface Props {
  rotation: number;
  show: boolean;
}

const props = defineProps<Props>();
const { rotation, show } = toRefs(props);
</script>

<template>
  <div
    v-if="show"
    :style="{ transform: `rotate(${rotation}rad)` }"
  >
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 54"
      fill="none"
      role="img"
      title="compass"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32"
        cy="27"
        r="24"
        fill="#AAC2CB"
      />
      <circle
        cx="32"
        cy="27"
        r="23"
        stroke="#14191B"
        stroke-width="2"
      />
      <circle
        cx="32"
        cy="27"
        r="20"
        fill="#0F2026"
      />
      <path
        d="M31.9995 10L36.9995 27H26.9995L31.9995 10Z"
        fill="#FC2D2D"
      />
      <path
        d="M31.9995 44L36.9995 27H26.9995L31.9995 44Z"
        fill="#AAC2CB"
      />
      <circle
        cx="32"
        cy="27"
        r="3"
        fill="#1D3740"
      />
    </svg>
  </div>
</template>
